<div class="nav-content px-0 mt-0">
  <div class="container-fluid">
      <!-- TESTING ONLY: instance switcher for QuickSight RLS. Remove before merging. -->
      @if (showInstanceSelector) {
        <div class="py-2">
          <label for="test-instance-select" class="mr-2">Test instance</label>
          <select id="test-instance-select" class="form-control d-inline-block w-auto"
            (change)="onTestInstanceChange($any($event.target).value)">
            <option value="">Session instance</option>
            @for (instance of testInstanceIds; track $index) {
              <option [value]="instance.id">{{ instance.name }}</option>
            }
          </select>
        </div>
      }
      <div class="iframe-wrap">
              <iframe
              #myIframe
              frameborder="0"
              width="100%"
              height="3200"
              allowtransparency
          ></iframe>
              @if (loading) {
                <div class="iframe-loader">
                  <div class="iframe-loader-card">
                    <i class="fas fa-spinner fa-spin fa-2x grey2 mb-2"></i>
                    <div class="grey3 nav-font14">Loading dashboard...</div>
                  </div>
                </div>
              }
      </div>
    </div>
    </div>


